import { useEffect, useState } from "react";
import { BubblyBubbles } from "../library/src/BubblyBubbles";

const COLOR_START = "#3FA9E0";
const COLOR_END = "#0A0E1A";
const BUBBLE_DURATION = 1100;
const VISIBLE_TIME = 2600;

export default function Preloader() {
  const [show, setShow] = useState(
    () => !sessionStorage.getItem("preloaderShown")
  );
  const [bubbles, setBubbles] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!show) return;

    document.body.style.overflow = "hidden";

    const tStart = setTimeout(() => setBubbles(true), VISIBLE_TIME);
    const tHide = setTimeout(() => setHidden(true), VISIBLE_TIME + BUBBLE_DURATION / 2);
    const tEnd = setTimeout(() => {
      sessionStorage.setItem("preloaderShown", "1");
      document.body.style.overflow = "";
      setShow(false);
    }, VISIBLE_TIME + BUBBLE_DURATION);

    return () => {
      clearTimeout(tStart);
      clearTimeout(tHide);
      clearTimeout(tEnd);
      document.body.style.overflow = "";
    };
  }, [show]);

  if (!show) return null;

  return (
    <>
      <div className={`preloader ${hidden ? "exit" : ""}`}>
        <div className="mono-wrap">
          <svg className="mono-svg" viewBox="0 0 180 120" aria-label="IO">
            <path className="bracket draw br-l" d="M40 35 L22 60 L40 85" />
            <line className="draw letter-I" x1="72" y1="38" x2="72" y2="82" />
            <path className="draw letter-O" d="M108 38 a22 22 0 1 0 0.01 0" />
            <circle className="mono-dot" cx="108" cy="60" r="6" />
            <path className="bracket draw br-r" d="M140 35 L158 60 L140 85" />
          </svg>
        </div>
        <div style={{ textAlign: "center" }}>
          <p className="pl-name">Iván Olivera</p>
          <p className="pl-role">
            Developer<span className="cursor">_</span>
          </p>
        </div>
        <div className="pl-bar">
          <i />
        </div>
      </div>

      {bubbles && (
        <div style={{ position: "fixed", inset: 0, zIndex: 110 }}>
          <BubblyBubbles
            colorStart={COLOR_START}
            colorEnd={COLOR_END}
            duration={BUBBLE_DURATION}
          />
        </div>
      )}
    </>
  );
}
